import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { Card, Row, Col, Button, Container, Alert } from 'react-bootstrap';
import { Form } from 'react-final-form';

import { CreditCard } from '@styled-icons/bootstrap/CreditCard';
import { Barcode } from '@styled-icons/boxicons-solid/Barcode';

import FormCartao from '../components/FormCartao';
import DetalhePagamento from '../components/DetalhePagamento';
import DetalheBoleto from '../components/DetalheBoleto';

import { checkoutstripe } from '../../../actions/pedidos/pedidos';

const Pagamentos = (props) => {    

    const [pagamento, setPagamento] = useState({});
    const [pedido, setPedido] = useState({});    
    const [formapagto, setFormPagamento] = useState(1);

    const handleSubmit = async (form) => {
        
    }

    const handleCarregaPedido = async () => {        
        const url = 'http://localhost:3001/app/pagamentos/68/43/76914/R/pt';
        const filtro = {
            idpromotora: props.match.params.idpromotora,
            idevento: props.match.params.idevento,
            idpedido: props.match.params.idpedido,
            fonte: props.match.params.fonte,
            urlretorno_cancel: url,
            urlretorno_success: url,
            chave_teste: 1
        }
        const result = await props.checkoutstripe(filtro);
        setPedido(result[0]?result[0]:{});
    }

    const handleLinkPagamento = (pagamento) => {
        window.location.href = pagamento.urlcheckout;
    }

    useEffect(() => {        
        handleCarregaPedido();
    },[]);
        
    return (
        <Form
        onSubmit={handleSubmit}
        render={({form, handleSubmit}) => {
            return (
                <Container>
                    <Row className="justify-content-md-center">
                    <Col md={{ span: 12, offset: 4 }}>
                        <Card.Body>
                            <Card.Title>
                                Pagamento
                            </Card.Title>
                            {pagamento&&pagamento.idstatus===7?
                            <Button variant="primary" onClick={() => handleLinkPagamento(pagamento)} block>
                                <CreditCard size="4em" />Fazer o Pagamento
                            </Button>
                            :
                            null
                            }
                            <Row className='mb-2'>
                            {(pagamento&&(pagamento.idstatus===2||pagamento.idstatus===5))?
                                <Alert variant={`${pagamento.idstatus===2?'info':'success'}`}>
                                    Pagamento Realizado
                                </Alert>
                                :
                                null
                            }
                                <Col className="col-3">
                                    <Button variant={formapagto===1?"primary":"outline-secondary"} onClick={() => setFormPagamento(1)} block>
                                        <CreditCard size="4em" /><br />Crédito
                                    </Button>
                                </Col>
                                <Col className="col-3">
                                    <Button variant={formapagto===2?"primary":"outline-secondary"} onClick={() => setFormPagamento(2)} block>
                                        <Barcode size="4em" /><br />Boleto
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                        </Col>
                    </Row>
                </Container>
            )
        }}
        >        
        </Form>
    )
}

export default connect(null,{checkoutstripe})(Pagamentos);